<div class="card">
  <div (click)="openGroupNewsDetailDialogBox()" class="image background-loading">
    <img [src]="groupNews.news?.imageUrl" alt="{{ groupNews.news?.title }}" appDefaultImage="assets/images/defaults/news.png" lazy="true" loading="lazy" />
    <div (click)="$event.stopPropagation(); $event.preventDefault(); navigateToGroupDetailsScreen()" class="date-wrapper">
      <p class="group-name">{{ groupNews?.group?.name }}</p>
    </div>
  </div>
  <div class="mt-12">
    <h4 (click)="openGroupNewsDetailDialogBox()" class="card__title">{{ groupNews.news?.title || '' | humanize }}</h4>

    <!-- Date and time -->

    <div class="date-time">
      <p class="date mt-16">
        <app-icon [cssStyle]="{ 'margin-top': '2px' }" color="var(--text-color-medium)" iconName="calendar" size="20px"></app-icon>
        {{ groupNews.news.publicationDateFrom | date: 'dd.MM.y' : '' }}
      </p>
      <!--  Date  -->
      <!--      <p class="time mt-14">-->
      <!--        <app-icon [cssStyle]="{ 'margin-top': '2px' }" [planeIcon]="true" color="var(&#45;&#45;text-color-medium)" iconName="calendar" size="20px"></app-icon>-->
      <!--        {{ groupNews.news?.publicationDateFrom | date : 'mm.dd.yyyy' }}-{{ groupNews.news?.publicationDateTo | date : 'mm.dd.yyyy' }}-->
      <!--        <span translate>Clock</span>-->
      <!--      </p>-->
    </div>
  </div>
  <div class="mt-14">
    <div class="card__user-details">
      <div class="user-image background-loading-tiny">
        <img [appFetchProfileImage]="groupNews?.news.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
      </div>

      <div class="text-alignment">
        <p class="role" translate>Author</p>
        <p class="user-name">{{ groupNews.news?.user?.fullName | translate }}</p>
      </div>
    </div>
  </div>
</div>
